var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Relatorio de Oportunidades")]),_c('b-card',[_c('FormOportunidades')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }